import React from 'react';
import { inject,observer } from 'mobx-react';
import { getAntd,getEcCom,getLabel } from '../../../util/convert';
import Content from './Content';

@inject('ehOperatorStore')
@observer
export default class Main extends React.Component{
    render(){
        const { WeaDialog } = getEcCom();
        const { visible } = this.props;
        return (
            <WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@xn91r7`}
                visible={visible}
                loadCss={true}
                initLoadCss={true}
                title={getLabel(384721,'请选择下一节点操作者')}
                icon="icon-coms-workflow"
                iconBgcolor='#0079DE'
                maskClosable={false}
                onCancel={this.doCancel}
                style={{width:"600px", height:"290px"}}
                layout={jQuery('.wf-req')[0]}
            >
                <Content ecId={`${this && this.props && this.props.ecId || ''}_Content@kjd8m4`} {...this.props} />
            </WeaDialog>
        )
    }
    doCancel = () => {
        const { ehOperatorStore } = this.props;
        ehOperatorStore.doCancel();
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/dialog/eh-operator/index.js